import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../PageHeader';
import {
  Table, Button, Skeleton, Empty, Typography, Space
} from 'antd';
import { axiosClient } from '../../apiClient';

const { Link } = Typography;

export default function SellerListShipping() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosClient
      .post('/shipping/get', { shippingId: false }, { withCredentials: true })
      .then((response) => {
        const values = response.data.shippings.map((v) => ({
          ...v,
          key: v.id,
        }));
        setData(values);
        setLoading(false);
      });
  }, []);

  const renderBuyers = (record) => (
    <Space direction="vertical">
      {record.buyer_condition === 'all' && 'Todos Clientes'}
      {record.buyer_condition !== 'all' && (
        (record.buyers_tags?.length > 0 && 'Por Tags') ||
        (record.buyers?.length > 0 && 'Clientes Específicos') ||
        (
          record.ceps_data &&
          (record.ceps_data.ceps_full?.length > 0 ||
            record.ceps_data.ceps_range?.length > 0 ||
            record.ceps_data.ceps_start?.length > 0) &&
          'Por CEP'
        )
      )}
    </Space>
  );

  const columns = [
    {
      title: 'Descrição',
      render: (record) => <Link>{record.nome}</Link>,
      ellipsis: true,
      responsive: ['sm'],
    },
    {
      title: 'Valor',
      render: (record) => (
        <>
          {record.metodo == 'personalizado'
            ? parseFloat(record.valor).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })
            : 'Cálculo automático no checkout'}
        </>
      ),
      responsive: ['sm'],
    },
    {
      title: 'A quem se aplica',
      render: renderBuyers,
      responsive: ['sm'],
    },
    {
      title: 'Métodos',
      render: (record) => (
        <>
          <Link>{record.nome}</Link>
          <br />
          {record.metodo == 'personalizado'
            ? parseFloat(record.valor).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })
            : 'Cálculo automático no checkout'}
          <br />
          {' '}
          <Space split="e">
            {renderBuyers(record)}
          </Space>
          <br />
        </>
      ),
      responsive: ['xs'],
      ellipsis: true,
    },
  ];

  return (
    <>
      <PageHeader
        title="Métodos de Entrega"
        onBack={() => navigate('/admin')}
        extra={(
          <Button
            onClick={() => {
              navigate('/admin/entrega/cadastro');
            }}
            type="primary"
          >
            Adicionar Método de Entrega
          </Button>
        )}
      />
      <Table
        columns={columns}
        dataSource={loading ? [] : data}
        locale={{
          emptyText: loading ? <Skeleton active /> : <Empty />,
        }}
        style={{ cursor: !loading ? 'pointer' : 'auto' }}
        onRow={(record, rowIndex) => ({
          onClick: (event) => {
            navigate(`/admin/entrega/cadastro/${record.id}`);
          },
        })}
      />
    </>
  );
}
